var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: '100%', height: `${_vm.height / 16}rem` }),attrs:{"id":_vm.id}},[_vm._v("sada")])
}
var staticRenderFns = []

export { render, staticRenderFns }